module.exports = __webpack_public_path__ + "img/zc3.9b9840da.png";